import Banner from 'components/Banner';
import React from 'react';
import { useTranslation } from 'services/localization';

export const StartAcceptingPaymentsBanner = () => {
	const { t } = useTranslation();

	return (
		<Banner
			variant="info"
			title={t('account.payments.startAcceptingPayments', 'Start accepting payments')}
			description={t(
				'account.payments.enablePaymentOptionsToAcceptOrders',
				'Enable a payment option to start receiving orders. Currently you have no payment options enabled and therefore cannot receive orders.',
			)}
		/>
	);
};
